// removed by extract-text-webpack-plugin
module.exports = {"emptyStatesContainer":"_22ZA5"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/search-page/search-page.scss
// module id = 1799
// module chunks = 0